import { APIResponse } from './types';

export type WebEvent = {
  url: string;
  hostname: string;
  categories: number[];
  categories_match: number[];
  action: ReportSiteAction;
  reason: ReportSiteReason;
  // YouTube metadata
  subtype?: string;
  video_title?: string;
  video_channel_title?: string;
  video_duration?: number;
};

export type ScreenTimeEvent = {
  ts: number;
  seconds: number;
};

export enum ReportSiteAction {
  ALLOW = 0,
  BLOCK = 1,
  ALERT = 2,
  IGNORE = 3,
}

export enum ReportSiteReason {
  NO_MATCH = 0,
  WHITELIST = 1,
  CATEGORY_BLOCK = 7,
  NOT_ALLOW_UNKNOWN_SITES = 9,
}

export type EventsReportResponse = APIResponse<
  {
    screen_time: {
      date: string;
      profile_uid: string;
      seconds: number;
      countable_seconds: number;
    };
  },
  Headers
>;
